export enum API_ACCESS_MODE {
  'PAYMENT_PAGE_MODE' = 'PAYMENT_PAGE_MODE',
  'SERVER_TO_SERVER_MODE' = 'SERVER_TO_SERVER_MODE',
}

export enum CALCULATION_VARIANTS {
  CALENDAR = 'CALENDAR',
  RELATIVE = 'RELATIVE',
}

export enum COMPARISON_TYPES {
  ABSOLUTE = 'ABSOLUTE',
  DIRECT_PERCENTAGE_DROP = 'DIRECT_PERCENTAGE_DROP',
  RELATIVE = 'RELATIVE',
}

export enum DATA_KEYS {
  ANALYTIC_DICTIONARIES = 'analytic_dictionaries',
  AUTH_DICTIONARIES = 'auth_dictionaries',
  BUILDER_DICTIONARIES = 'builder_dictionaries',
  DICTIONARIES = 'dictionaries',
  ROLES = 'roles',
}

export enum DATA_TYPE {
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  PASSWORD = 'PASSWORD',
  STRING = 'STRING',
}

export enum DEVIATION_TYPES {
  ALWAYS_TRACKING = 'ALWAYS_TRACKING',
  DECREASE = 'DECREASE',
  INCREASE = 'INCREASE',
}

export enum LIMIT_TYPE {
  AMOUNT = 'AMOUNT',
  COUNT = 'COUNT',
}

export enum NOTIFICATION_TYPES {
  APPROVAL_RATE = 'APPROVAL_RATE',
  SINGLE_TRANSACTION = 'SINGLE_TRANSACTION',
  STUCK_TRANSACTIONS = 'STUCK_TRANSACTIONS',
}

export enum PERIOD_TYPE_VARIANTS {
  CUSTOM = 'CUSTOM',
  DAY = 'DAY',
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

export enum SETTLEMENT_TYPE {
  ACQUIRING = 'ACQUIRING',
  CASHIER = 'CASHIER',
  REFERRAL = 'REFERRAL',
}
